"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferType = exports.State = exports.Direction = void 0;
/* Input objects - BEGIN */
// List of transfer direction options
var Direction;
(function (Direction) {
    Direction["SEND"] = "send";
    Direction["RECEIVE"] = "receive";
})(Direction = exports.Direction || (exports.Direction = {}));
// List of transfer state options
var State;
(function (State) {
    State["IN_PROGRESS"] = "In Progress";
    State["POST_PROCESSING"] = "Post Processing";
    State["COMPLETE"] = "Complete";
    State["FAILED"] = "Failed";
    State["EXPIRED"] = "Expired";
    State["DELETED"] = "Deleted";
    State["PURGED"] = "Purged";
    State["ERROR"] = "Error";
})(State = exports.State || (exports.State = {}));
// List of types of Faspex transfers
var TransferType;
(function (TransferType) {
    TransferType["CONNECT"] = "connect";
    TransferType["GATEWAY"] = "http_gateway";
    TransferType["REMOTE"] = "remote_transfer";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
/* Faspex metadata types - END */
